import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { STATE_AND_CITIES } from "../../../utils/StateAndCities";
import { Select } from "antd";
import { If } from "react-condition";

const { Option } = Select;

function StateCity({ onBlurHandler, data, defaultValue, isChild, approve, ocrDisabled, errorInputs }) {
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "statecity",
    properties: {
      placeholder: "Enter here...",
      required: true,
    },
    value: {},
  });

  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [flag, setFlag] = useState(false);

  useEffect(() => {
      const obj = { ...data };
      setElement((prevElement) => ({
        ...prevElement,
        ...obj,
        value : {
          state : data.value?.state || "",
          city : data.value?.city || ""
        }
      }));
      setFlag(!flag)
  }, [data]);

  useEffect(() => { 
    let rawState = String(data?.value?.state || "").trim();
    let rawCity = String(data?.value?.city || "").trim();

    let matchedState = Object.keys(STATE_AND_CITIES).find(
      (s) => s.toLowerCase() === rawState.toLowerCase()
    ) || rawState;

    let matchedCity = rawCity;
    if (matchedState && STATE_AND_CITIES[matchedState]) {
      let cityObj = STATE_AND_CITIES[matchedState].find(
        (c) => c.city.toLowerCase() === rawCity.toLowerCase()
      );
      if (cityObj) {
        matchedCity = cityObj.city;
      }
    }

    setState(matchedState);
    setCity(matchedCity);
  }, [flag, data]);

  console.log({element,state,city,data})


  const onChangeHandlerState = (value) => {
    setState(value);
    setElement((prevElement) => ({
      ...prevElement,
      value: {
        ...prevElement.value,
        state: value,
        city: "",
      },
    }));
    setCity("");
  };

  const onChangeHandlerCity = (value) => {
    setCity(value);
    setElement((prevElement) => ({
      ...prevElement,
      value: {
        ...prevElement.value,
        city: value,
      },
    }));
  };

  console.log(element,"OOOOOOOOOOOOOOOOOO")

  const foundErrorState = errorInputs?.find(ele => ele?.label === 'Select State');
  const foundErrorCity = errorInputs?.find(ele => ele?.label === 'Select City');

  return (
    <div
      className="form-group col-md-12 form-builder-element mb-3 form-view"
      data={JSON.stringify(element)}
    >
      <div className="">
        <label htmlFor="state">
          Select State
          <If test={element?.properties?.required === true}><span style={{color:'red'}}>*</span></If>
        </label>
        <Select
          key={state}
          id="state"
          showSearch
          className={`${foundErrorState ? "border border-danger" : ""}`}
          disabled = {approve || !element.editable}
          style={{ width: "100%", height: "37px" }}
          placeholder="Select State"
          optionFilterProp="children"
          value={state}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          onChange={onChangeHandlerState}
        >
          {Object.keys(STATE_AND_CITIES).map((state) => (
            <Option key={state} value={state}>
              {state}
            </Option>
          ))}
        </Select>
        {
          foundErrorState && <span className="text-danger">{foundErrorState?.value}</span>
        }
      </div>
      {state && (
        <div className="mt-3">
          <label htmlFor="city">
            Select City
           <span style={{color:'red'}}>*</span>
          </label>
          <Select
            id="city"
            disabled = {approve || !element.editable}
            value={city}
            showSearch
            className={`${foundErrorCity ? "border border-danger" : ""}`}
            style={{ width: "100%", height: "37px" }}
            placeholder="Select City"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            onChange={onChangeHandlerCity}
          >
            {STATE_AND_CITIES[state] &&
              STATE_AND_CITIES[state].map((cityObj) => (
                <Option key={cityObj.city} value={cityObj.city}>
                  {cityObj.city}
                </Option>
              ))}
          </Select>
          {
            foundErrorCity && <span className="text-danger">{foundErrorCity?.value}</span>
          }
        </div>
      )}
    </div>
  );
}

export default StateCity;
